import { render, staticRenderFns } from "./applyDetails.vue?vue&type=template&id=33ba9796&scoped=true"
import script from "./applyDetails.vue?vue&type=script&lang=js"
export * from "./applyDetails.vue?vue&type=script&lang=js"
import style0 from "./applyDetails.vue?vue&type=style&index=0&id=33ba9796&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ba9796",
  null
  
)

export default component.exports